import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CategoryForm from "./CategoryForm";
import TypeLinkForm from "./TypeLink";
import axios from "axios";
import { setEditingCategory, setShowForm , setLinkForm} from "./redux/categorySlice";
import Popup from "../Popup";
import TableComponent from "../table/tableComponent";
import API_BASE_URL from "../config";
// import {
//   fetchClassesThunk,
//   ,
// } from "./redux/chapterThunk";
import { fetchCategoriesThunk } from "./redux/categoryThunk";
import {
  fetchClassesThunk,
  fetchSubjectsByClassThunk,
} from "../chapter/redux/chapterThunk";

export default function ViewCategory() {
  const dispatch = useDispatch();
  const { categories, loading, showForm, linkForm ,editingCategory } = useSelector(
    (state) => state.category
  );
  const { classes, subjects } = useSelector((state) => state.chapter);

  const [selectedClass, setSelectedClass] = useState("");
  const [selectedSubject, setSelectedSubject] = useState("");

  // ✅ Fetch categories, classes initially
  useEffect(() => {
    dispatch(fetchCategoriesThunk());
    dispatch(fetchClassesThunk());
  }, [dispatch]);

  // ✅ Fetch subjects when class changes
  useEffect(() => {
    if (selectedClass) {
      dispatch(fetchSubjectsByClassThunk(selectedClass));
    }
  }, [selectedClass, dispatch]);

  const handleCreateNew = () => {
    dispatch(setEditingCategory(null));
    dispatch(setShowForm(true));
  };

  const handleEditClick = (item) => {
    dispatch(setEditingCategory(item));
    dispatch(setShowForm(true));
  };
  const handleLinkClick = (item) => {
    //debugger
    dispatch(setEditingCategory(item));
    dispatch(setLinkForm(true));
  };

  const handleFormCancel = () => {
    dispatch(setEditingCategory(null));
    dispatch(setShowForm(false));
  };
  const handleLinkFormCancel = () => {
    dispatch(setEditingCategory(null));
    dispatch(setLinkForm(false));
  };

const handleToggleStatus = async (type_id) => {
  const confirmed = window.confirm("Are you sure you want to change the status?");
  if (!confirmed) return;

  try {
    await axios.put(`${API_BASE_URL}/classes/update-status/${type_id}`);
    // After toggle, fetch updated data
    dispatch(fetchCategoriesThunk());
  } catch (error) {
    console.error("Failed to toggle status:", error);
    alert("Error toggling status");
  }
};



  // ✅ Updated column order: Class → Subject → Category Name → Description → Actions
  const tableColumns = [
    { Header: "S. No", accessor: "type_id" },
    { Header: "Name", accessor: "type_name" },
    { Header: "Title", accessor: "type_title" },
    { Header: "Status", accessor: "status" },
     { Header: "Actions", accessor: "actiontd" },
  ];

  const processData = (data) =>
    data.map((item, index) => ({
      ...item,
      sno: index + 1,
      status: (
      <button
        onClick={() => handleToggleStatus(item.type_id)}
        style={{
          backgroundColor: item.is_active === 1 ? "green" : "red",
          color: "white",
          fontWeight: "bold",
          border: "none",
          borderRadius: "4px",
          padding: "4px 8px",
          cursor: "pointer",
        }}
      >
        {item.is_active === 1 ? "Active" : "Inactive"}
      </button>
    ),
      actiontd: (
        <>
        <i
          className="fa fa-pencil mx-2"
          style={{ color: "blue", cursor: "pointer" }}
          title="Edit"
          onClick={() => handleEditClick(item)}
        ></i>
        
        <i
          className="fa fa-link mx-2"
          style={{ color: "violet", cursor: "pointer" }}
          title="Link"
          onClick={() => handleLinkClick(item)}
        ></i>
        </>
      ),
    }));

  if (loading) {
    return <p>Loading categories...</p>;
  }

  return (
    <div>
      {/* Title & Create Button */}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
          position: "relative",
        }}
      >
        <h2 style={{ textAlign: "center" }}>Question Types</h2>
        <button
          style={{
            color: "#fff",
            backgroundColor: "blue",
            borderRadius: "5px",
            padding: "5px 10px",
            position: "absolute",
            right: "0",
            borderStyle: "none",
            cursor: "pointer",
          }}
          onClick={handleCreateNew}
        >
          Create Category
        </button>
      </div>

      
      

      {/* Table */}
      <TableComponent
        tableColumns={tableColumns}
        tableData={processData(categories)}
      />

      {/* Popup Form */}
      {showForm && (
        <Popup
          title={editingCategory ? "Edit Category" : "Add New Category"}
          onClose={handleFormCancel}
          maxWidth="1000px"
          minHeight="400px"
        >
          <CategoryForm />
        </Popup>
      )}
      {linkForm && (
        <Popup
          title={"Link Question type with subjects & class"}
          onClose={handleLinkFormCancel}
          maxWidth="1000px"
          minHeight="400px"
        >
          <TypeLinkForm />
        </Popup>
      )}
    </div>
  );
}
